import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import BlofinLiveOrderPanel from './BlofinLiveOrderPanel';

export default function BlofinManualOrderPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: 'auto' }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ sm: 'center' }} spacing={1}>
        <Typography variant="h4" gutterBottom>Ordres BloFin</Typography>
        <Button component={RouterLink} to="/trading/stats" variant="outlined">Statistiques LIVE</Button>
      </Stack>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Interface LIVE uniquement. La préparation d&apos;une intention ne déclenche aucun ordre ;
        la confirmation explicite reste requise avant MARKET.
      </Typography>
      <BlofinLiveOrderPanel />
    </Box>
  );
}
